export default __webpack_public_path__ + "static/media/print.9fc1251d.svg";